import React from 'react'

const Technology = () => {
    return (
        <div className="skills__content">
        <h3 className="skills__title">Technology</h3>
    
        <div className="skills__box">
            <div className="skill__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Vs code</h3>
                        <span className="skills__level">used</span>
                    </div>
                </div>
    
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Postmon</h3>
                        <span className="skills__level">used</span>
                    </div>
                </div>
    
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Git</h3>
                        <span className="skills__level">Intermidiate</span>
                    </div>
                </div>
    
    
            </div>
    
            <div className="skill__group">
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">GitHub</h3>
                        <span className="skills__level">Basic</span>
                    </div>
                </div>
    
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">Rest Api</h3>
                        <span className="skills__level">used</span>
                    </div>
                </div>
    
                <div className="skills__data">
                    <i className="bx bx-badge-check"></i>
                    <div>
                        <h3 className="skills__name">chatgpt4</h3>
                        <span className="skills__level">Complete</span>
                    </div>
                </div>
    
                
            </div>
        </div>
    </div>
      )
}

export default Technology;
